var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useListLeagueHomeVenues } from "../api/LeagueVenueApiProvider";
import { useRetrieveUserLeagueMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveLeagueMatch, useRetrieveSeason, useUpdateLeagueMatch, } from "../api/SeasonApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { LeagueMatchForm } from "./LeagueMatchForm";
export var UpdateLeagueMatch = function () {
    var _a;
    var _b = useNumericParams(), leagueId = _b.leagueId, seasonId = _b.seasonId, id = _b.id;
    var navigate = useNavigate();
    var _c = useRetrieveUserLeagueMatchPermissions({ leagueMatchId: id }), permissions = _c.data, permissionsLoading = _c.isLoading, permissionsError = _c.error;
    var _d = (permissions || {}).canModify, canModify = _d === void 0 ? false : _d;
    var _e = useRetrieveLeagueMatch({ id: id, enabled: canModify }), leagueMatch = _e.data, matchLoading = _e.isLoading, matchError = _e.error;
    var _f = useRetrieveSeason({ id: seasonId, enabled: canModify }), season = _f.data, seasonLoading = _f.isLoading, seasonError = _f.error;
    var _g = useListLeagueHomeVenues({ leagueId: leagueId, enabled: canModify }), _h = _g.data, leagueVenues = _h === void 0 ? [] : _h, venuesLoading = _g.isLoading;
    var mutation = useUpdateLeagueMatch({
        onSuccess: function () {
            navigate("/leagues/".concat(leagueId, "/seasons/").concat(seasonId, "?tab=fixtures"));
        },
    });
    var onSubmit = function (data) {
        mutation.mutate(__assign(__assign({}, data), { id: id }));
    };
    if (permissionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (matchLoading || seasonLoading || venuesLoading) {
        return _jsx(Loading, {});
    }
    if (matchError || seasonError || !leagueMatch || !season) {
        return _jsx(ErrorView, { error: matchError || seasonError });
    }
    var divisions = (_a = season.divisions) !== null && _a !== void 0 ? _a : [];
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update match. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsx("strong", { children: "Update League Match" }) }), _jsx(LeagueMatchForm, { divisions: divisions, leagueVenues: leagueVenues, onSubmit: onSubmit, leagueMatch: leagueMatch, isSubmitting: mutation.isLoading })] }));
};
